<script>
export let name = '';
</script>

<p class="text-blue-700 italic text-center">Loading {name}...</p>